import { createActions } from '../utils/actions';

const { actions: mediaLibrary } = createActions('mediaLibrary')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('createFolder')
  .addAsync('deleteFolder')
  .addAsync('deleteImages')
  .addAsync('downloadImages')
  .add('editImages')
  .addAsync('getFolders')
  .addAsync('getImages')
  .addAsync('moveImages')
  .addAsync('renameFolder')
  .addAsync('saveImage')
  .add('setValue')
  .add('toggleImageState')
  .addAsync('updateImage')
  .addAsync('uploadFiles');

export default mediaLibrary;
